import env from "@/utils/env";
import { getbannerlistApi, getaboutlistApi, getproductlistApi, shoppinglistApi } from "@/api/home";
import { deliverylistAPI } from "@/api/pubilcapi";
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions
} from 'vuex';
export default {
  data() {
    return {
      // 轮播图
      bannerlist: [],
      // 关于我们
      aboutinfo: null,
      // 包装展示
      baozhuanglist: [],
      // 服务展示
      servicelist: [],
      // 配送方式
      deliverylist: [],
    };

  },
  computed: {
    ...mapState(['user'])
  },
  methods: {
    ...mapActions(['getUser']),
    ...mapMutations(['logout']),
    // 获取配送列表
    async getdeliverylist() {
      const res = await deliverylistAPI()
      this.deliverylist = res.data
    },
    // 获取轮播图列表
    async getbannerlist(type) {
      let res = await getbannerlistApi({
        type: type
      });
      this.bannerlist = res.data;
    },
    // 获取关于我们列表
    async getaboutlist() {
      let res = await getaboutlistApi({});
      this.aboutinfo = res.data;
    },
    // 获取产品展示
    async getproductlist() {
      let res = await getproductlistApi({});
      let list = res.data;
      this.baozhuanglist = list.filter(x => x.type == 1);
      this.servicelist = list.filter(x => x.type == 2);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth * 1.2;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop, data) {
      // 将表头加入数组
      const arr = data.map((x) => x[prop]);
      arr.push(label);
      // 计算每列内容最大的宽度
      const maxWidth = arr.reduce((acc, item) => {
        if (item) {
          const width = this.getTextWidth(item);
          acc = Math.max(acc, width);
        }
        return acc;
      }, 0);
      // 返回最大宽度加上额外的内间距
      return maxWidth + 25 + "px";
    },

    // 封装重置
    resetForm(form) {
      for (const key in form) {
        if (typeof form[key] === "string") {
          form[key] = "";
        } else if (key == "page") {
          form[key] = 1;
        } else {
          form[key] = null;
        }
      }
    },
    // 图片拼接
    imgUrl(url) {
      if (!/^https?:\/\//i.test(url)) {
        // 如果不是以 http 或 https 开头，进行拼接（假设需要拼接一个基础 URL）
        return env.imgUrl + url
      }
      return url;
    },
    // 生成 4 个独立随机数字
    getRandomNumbers() {
      const randomDigits = Array.from({ length: 4 }, () => Math.floor(Math.random() * 10));
      return randomDigits;
    },

    // 下载地址拼接
    downloadUrl(url) {
      return env.imgUrl + url;
    },

    // 导出
    exportExcel(url, name) {
      let a = document.createElement("a");
      a.href = this.downloadUrl(url);
      a.download = name;
      a.target = '_blank';
      a.click();
      a.remove();
    },
    // 处理时间戳拿到今天的日期yyyy-mm-dd
    getTodayDate(time) {
      let data
      if (String(time).length != 13) {
        data = new Date(time * 1000);
      } else {
        data = new Date(time);
      }
      let year = data.getFullYear()
      let month = data.getMonth() + 1 >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1)
      let day = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate()
      return `${year}-${month}-${day}`;
    },
    // 处理时间戳拿到今天的日期yyyy-mm-dd hh:mm
    getTodayDatetime(time) {
      let data
      if (String(time).length != 13) {
        data = new Date(time * 1000);
      } else {
        data = new Date(time);
      }
      let year = data.getFullYear()
      let month = data.getMonth() + 1 >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1)
      let day = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate()
      let hour = data.getHours() >= 10 ? data.getHours() : '0' + data.getHours()
      let minute = data.getMinutes() >= 10 ? data.getMinutes() : '0' + data.getMinutes()
      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    //根据id查对应的内容
    findItemById(list, id) {
      for (const item of list) {
        // 检查当前项
        if (item.id === id) {
          return item;
        }

        // 如果有子项，递归查找
        if (item.children && item.children.length > 0) {
          const found = findItemById(item.children, id);
          if (found) {
            return found;
          }
        }
      }
      return null; // 如果没找到返回null
    },
    // 复制文本
    async copyText(value) {
      let text = ''
      if (value == '') {
        text = '复制这段文本！'
      } else {
        text = value
      }
      try {
        await navigator.clipboard.writeText(text);
        this.$message.success('复制成功！');
      } catch (err) {
        // console.error('Failed to copy text: ', err);
        this.$message.error('复制失败！');
      }
    },
    // 处理字段
    renameTextTolabel(arr) {
      if (!Array.isArray(arr)) {
        return arr;
      }

      return arr.map(item => {
        if (typeof item !== 'object' || item === null) {
          return item;
        }

        const newItem = {};

        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            if (key === 'text') {
              newItem['label'] = item[key];
            } else if (key === 'children') {
              newItem[key] = this.renameTextTolabel(item[key]);
            } else {
              newItem[key] = this.renameTextTolabel(item[key]);
            }
          }
        }

        return newItem;
      });
    },
  },
};
